<template>
  <div :class="{ 'bg-white': isWhite }">
    <div class="button-container">
      <button>
        <slot></slot>
      </button>
      <span></span>
      <div class="top-line"></div>
      <div class="bottom-line"></div>
      <div class="left-vertical"></div>
      <div class="right-vertical"></div>
    </div>
  </div>
</template>

<script>
// import CustomBordersTemplate from "@/components/templates/CustomBordersTemplate.vue";

export default {
  name: "custom-button",
  // components: { CustomBordersTemplate },
  props: {
    isWhite: {
      type: Boolean,
      default: () => false,
    },
    borderType: {
      type: String,
      default: () => "bg-black",
    },
  },
};
</script>

<style lang="scss" scoped>
button {
  background: black;
  height: 70px;
  width: 100%;
  border: 1px solid black;
  color: white;
  text-transform: uppercase;
  font-family: "UAF Sans H", serif;
  font-size: 22px;
  position: relative;
  cursor: pointer;

  @media (max-width: 767px) {
    height: 66px;
  }
}

.bg-white {
  button {
    color: black;
    background: white;
    border: 1px solid white;
  }
}

.border {
  width: 100%;
  height: 90px !important;
  background-repeat: no-repeat !important;
  display: flex;
  align-items: center;
  padding-left: 10px;

  &.bg-white {
    background: url("@/assets/images/border-white.png") !important;
  }

  &.bg-black {
    background: url("@/assets/images/border-black.png");
    background-size: contain !important;
  }
}

.button-container {
  position: relative;
  display: inline-block;
  width: calc(100% - 20px);
  transition: 0.3s;
  margin: 0 10px;
  box-sizing: border-box;
}

.button {
  padding: 10px 20px;
  background-color: transparent;
  color: white;
  border: none;
  cursor: pointer;
  position: relative;
  z-index: 1;
}

/* Уголки */
.button-container::before,
.button-container::after,
.button-container > span::before,
.button-container > span::after {
  content: "";
  position: absolute;
  width: 10px;
  height: 10px;
  border: 2px solid #000;
  z-index: 0;
}

.bg-white {
  .button-container .left-vertical,
  .button-container .right-vertical,
  .button-container .top-line,
  .button-container .bottom-line {
    background: #fff;
    color: #fff;
  }

  .button-container::before,
  .button-container::after,
  .button-container > span::before,
  .button-container > span::after {
    border: 2px solid #fff;
  }
}

.button-container::before {
  top: -10px;
  left: -10px;
  border-right: none !important;
  border-bottom: none !important;
}

.button-container::after {
  top: -10px;
  right: -10px;
  border-left: none !important;
  border-bottom: none !important;
}

.button-container > span::before {
  bottom: -10px;
  left: -10px;
  border-right: none !important;
  border-top: none !important;
}

.button-container > span::after {
  bottom: -10px;
  right: -10px;
  border-left: none !important;
  border-top: none !important;
}

/* Горизонтальные линии */
.button-container .top-line,
.button-container .bottom-line {
  position: absolute;
  height: 2px;
  background: #000;
  opacity: 0;
  transition: opacity 0s;
}

.button-container .top-line {
  top: -10px;
  left: -10px;
  width: 0;
}

.button-container .bottom-line {
  bottom: -10px;
  right: -10px;
  width: 0;
}

/* Вертикальные линии */
.button-container .left-vertical,
.button-container .right-vertical {
  position: absolute;
  width: 2px;
  background: #000;
  opacity: 0;
  transition: opacity 0s;
}

.button-container .left-vertical {
  top: -10px;
  left: -10px;
  height: 12px; /* Начальная высота равна уголку */
}

.button-container .right-vertical {
  bottom: -10px;
  right: -10px;
  height: 12px; /* Начальная высота равна уголку */
}

/* Анимация при наведении */
.button-container:hover .top-line {
  opacity: 1;
  animation: drawTop 0.5s forwards;
}

.button-container:hover .bottom-line {
  opacity: 1;
  animation: drawBottom 0.5s forwards;
}

.button-container:hover .left-vertical {
  opacity: 1;
  animation: stretchVertical 0.8s alternate;
}

.button-container:hover .right-vertical {
  opacity: 1;
  animation: stretchVerticalB 0.8s forwards;
}

@keyframes drawTop {
  from {
    width: 0;
  }
  to {
    width: calc(100% + 20px);
  }
}

@keyframes drawBottom {
  from {
    width: 0;
  }
  to {
    width: calc(100% + 20px);
  }
}

@keyframes stretchVertical {
  0% {
    width: 1px;
  }
  50% {
    width: 60px;
    transform: translateX(-30px);
  }
  100% {
    width: 1px;
    transform: translateX(0px);
  }
}

@keyframes stretchVerticalB {
  0% {
    width: 1px;
  }
  50% {
    width: 60px;
    transform: translateX(30px);
  }
  100% {
    width: 1px;
    transform: translateX(0px);
  }
}
</style>
